import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConvertibilityNotConvertible = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "convertibility-NotConvertible",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17539",
		"data-name": "Group 17539",
		transform: "translate(2 2.393)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13030",
				"data-name": "Path 13030",
				d: "M14.948,11.1V9h-2.1",
				transform: "translate(4.897 -10.66) rotate(45)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13032",
				"data-name": "Path 13032",
				d: "M9,5H4.333A1.333,1.333,0,0,0,3,6.333v8a1.333,1.333,0,0,0,1.333,1.333H13a1.333,1.333,0,0,0,1.333-1.333V11",
				transform: "translate(-3 -4.06)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_13037",
				"data-name": "Path 13037",
				d: "M8.333,15.667H13a1.333,1.333,0,0,0,1.333-1.333v-8A1.333,1.333,0,0,0,13,5H4.333A1.333,1.333,0,0,0,3,6.333V9.667",
				transform: "translate(-3 -4.06)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_4",
				"data-name": "Line 4",
				x2: 6,
				transform: "translate(2.5 6.273)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeWidth: 1
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_13036",
		"data-name": "Path 13036",
		d: "M0,0H16V16H0Z",
		fill: "none"
	})]
});
export default SvgConvertibilityNotConvertible;
